export const MARKETING_CTA = {
  requestAccess: { label: 'Request Access', to: '/access' },
  comparePlans: { label: 'Compare Plans', to: '/pricing' },
  validationEngine: { label: 'See Validation Engine', to: '/features' },
  recommendationLifecycle: { label: 'See Recommendation Lifecycle', to: '/how-it-works' },
} as const;

export const EARLY_ACCESS_BADGE = {
  label: 'EARLY ACCESS',
  detail: 'Controlled rollout in progress',
} as const;

export const ACCESS_GOVERNANCE = {
  phase: 'Phase 1 · Founding Access Cohort',
  onboardingWave: 'Wave 03',
  weeklyCapacity: 75,
  inviteOnly: false,
  manualApproval: true,
} as const;

export const MARKETING_PRODUCT_ITEMS = [
  {
    to: '/products/diamondedge',
    label: 'DiamondEdge (MLB)',
    detail: 'Live module intelligence engine',
  },
  {
    to: '/products/gridironedge',
    label: 'GridironEdge (NFL)',
    detail: 'Roadmap module',
  },
  {
    to: '/products/courtedge',
    label: 'CourtEdge (NBA/WNBA)',
    detail: 'Roadmap module',
  },
  {
    to: '/products/iceedge',
    label: 'IceEdge (NHL)',
    detail: 'Roadmap module',
  },
  {
    to: '/products/pitchedge',
    label: 'PitchEdge (Soccer)',
    detail: 'Roadmap module',
  },
] as const;
